import { render, staticRenderFns } from "./NumberText.vue?vue&type=template&id=6631e1c1&scoped=true"
import script from "./NumberText.vue?vue&type=script&lang=js"
export * from "./NumberText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6631e1c1",
  null
  
)

export default component.exports